module.exports = __webpack_public_path__ + "img/aeroland-payment-image-01.6481d35a.png";